angular
    .module('app')
    .directive('focus',
    function($timeout) {
        return {
            scope : {
                trigger : '@focus'
            },
            link : function(scope, el, attrs) {
                var params;
                if (attrs.focus)
                    params = eval('(' + attrs.focus + ')');
                
                scope.$watch('trigger', function(value) {
                    if (params) {
                        $timeout(function() {
                            el[0].focus();
                            el[0].select();
                        });
                    } else {
                        $timeout(function() {
                            el[0].focus();
                        });
                    }
                });
            }
        };
    })
    .directive('focusByCondition', function($timeout) {
        return {
            scope: { trigger: '@focusByCondition' },
                link: function(scope, element) {
                    scope.$watch('trigger', function(value) {
                        if (value == 'true') { 
                            $timeout(function() {
                                element[0].focus(); 
                            });
                        }
                    });
            }
        };
    });